import { useMemo, useState } from 'react'

import { Form } from 'antd'
import styled from 'styled-components'

import { TemplateRendererNew } from '../templateRenderer/TemplateRenderer'
import generateTemplateIds from '../templateRenderer/utils/generateTemplateIds'

import { CorePageSidePortal } from '@/components/layout-components/CorePageSidePortal'
import { Button } from '@/components/shared-components/BUI/Button'
import { Modal } from '@/components/shared-components/BUI/Modal'
import { Flexbox } from '@/components/shared-components/Flexbox'
import { useTemplateEditor } from '@/context/templateEditorContext'
import { SwmsTemplateRenderer } from '@/modules/swms-builder/SwmsTemplateRenderer'

import { Resource, TemplateType } from 'types/api.graphql'

const SidePanel = styled.div`
  padding: 1rem;
`

export const Preview = styled.span`
  position: sticky;
  top: 80px;
  width: 100%;
  height: 0; // take up no space
  z-index: 1;
  ${({ theme }) => theme.font.heading01};
  color: ${({ theme }) => theme.colour.secondary._100};
  text-shadow: 1px 1px 1px ${({ theme }) => theme.colour.secondary._400};
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;
  transform: translate(30%, 10%) rotate(45deg);
  transform-origin: top left;
  display: block;
`

export const PreviewFullscreen = styled(Preview)`
  transform: translate(50%, 10%) rotate(45deg);
`

export const SidePreview = () => {
  const { template, templateType } = useTemplateEditor()
  const [fullscreen, toggleFullscreen] = useState(false)
  const [form] = Form.useForm()

  const openFullscreen = () => toggleFullscreen(true)
  const closeFullscreen = () => toggleFullscreen(false)

  const finalTemplate = useMemo(() => generateTemplateIds(template), [template])

  const key = useMemo(() => {
    return JSON.stringify(template ?? {}) // forces a re-render when the template changes
  }, [template])

  return (
    <CorePageSidePortal>
      <SidePanel>
        <Flexbox justifyContent="flex-end" mb="1rem">
          <Button size="small" onClick={openFullscreen}>
            Preview fullscreen
          </Button>
        </Flexbox>
        <Preview>Preview only</Preview>
        <Form layout="vertical" form={form}>
          <TemplateRendererNew
            key={key}
            resource={Resource.Template}
            projectId={null} // project id is irrelevant for preview
            renderOptions={{ isPreview: true }}
            templateData={finalTemplate}
            form={form}
          />
        </Form>
      </SidePanel>

      <Modal fullscreen open={fullscreen} onCancel={closeFullscreen}>
        <Form layout="vertical" form={form}>
          {templateType === TemplateType.Swms ? (
            <>
              <PreviewFullscreen>Preview only</PreviewFullscreen>
              <SwmsTemplateRenderer
                swmsTemplate={template}
                projectId={null} // project id is irrelevant for preview
              />
            </>
          ) : (
            <>
              <PreviewFullscreen>Preview only</PreviewFullscreen>
              <TemplateRendererNew
                key={key}
                resource={Resource.Template}
                projectId={null} // project id is irrelevant for preview
                renderOptions={{ isPreview: true }}
                templateData={finalTemplate}
                form={form}
              />
            </>
          )}
        </Form>
      </Modal>
    </CorePageSidePortal>
  )
}
